import {viewModel as PurgeViewModel} from "./purge";
import {TServiceName} from "../../../constants/ApiServices";
import purgeHtml from './purge.html?raw';

export let template: string = purgeHtml;

export class viewModel extends PurgeViewModel {

    protected override serviceName: TServiceName = "deleteobject";

}
